

































































































import Vue from 'vue'
import { Component, Emit, Prop, VModel, Watch } from 'vue-property-decorator'

import { defaultShopTypeOfSelectedTariff } from '../logic/helpers'
import { Getaway, Payment, SelectedShop, Shop, Tariff } from '../logic/types'
import CurrencySelect from './CurrencySelect.vue'
import MakePayment from './MakePayment.vue'

@Component({
  components: {
    MakePayment,
    CurrencySelect
  }
})
export default class MerchantSelectModal extends Vue {
  @VModel() isModalOpen!: boolean

  @Prop() selectedTariff!: Tariff | null

  @Prop() initShop!: SelectedShop | null

  @Prop({ type: Boolean, default: false }) multiplePayment!: boolean

  @Prop({ type: Function }) calcTotalFn!: (price: string) => number

  @Watch('isSelectedTariffPopupOpen')
  onSelectedTariffPopupOpenChange(value: boolean): void {
    if (value) {
      if (!this.initShop) {
        const shop = defaultShopTypeOfSelectedTariff(this.shops as { [key in Shop]: Array<Getaway> })

        if (shop?.group === 'global') {
            this.selectedShop = this.shops?.global?.[0] as Getaway ?? null
        } else {
          this.selectedShop = shop
        }
      } else {
        this.selectedShop = this.initShop
      }
    }
  }

  @Emit()
  private generatePayment(payment: Payment | null): Payment | null {
    if (payment) {
      this.$nextTick(() => {
        this.isSelectedTariffPopupOpen = false
      })
    }

    return payment
  }

  @Emit()
  clearSelectedTariff() {
    return null
  }

  @Emit()
  clearInitShop() {
    return null
  }

  getaway: Getaway | null = null

  selectedShop: SelectedShop | null = null

  get tariffCardBodyStyles(): Partial<CSSStyleDeclaration> {
    return {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem'
    }
  }

  get shops(): Tariff['shops'] | null {
    return this.selectedTariff ? this.selectedTariff.shops : null
  }

  get isSelectedTariffPopupOpen(): boolean {
    return this.selectedTariff !== null
  }

  set isSelectedTariffPopupOpen(newValue: boolean) {
    if (!newValue) {
      this.clearSelectedTariff()
      this.clearInitShop()
    }
  }

  updateGetaway(getaway: Getaway): void {
    this.getaway = getaway
  }
}
